// import React from 'react';
// import { useEditor } from '@tiptap/react';
// import StarterKit from '@tiptap/starter-kit';
// import Underline from '@tiptap/extension-underline';
// import TextAlign from '@tiptap/extension-text-align';
// import Link from '@tiptap/extension-link';
// import TextStyle from '@tiptap/extension-text-style';
// import Color from '@tiptap/extension-color';
// import Image from '@tiptap/extension-image';
// import FontSize from '@tiptap/extension-font-size';

// import {
//     RichTextEditorProvider,
//     RichTextField,
//     MenuControlsContainer,
//     MenuSelectHeading,
//     MenuButtonBold,
//     MenuButtonItalic,
//     MenuButtonUnderline,
//     MenuDivider,
//     MenuButtonAlignLeft,
//     MenuButtonAlignCenter,
//     MenuButtonAlignRight,
//     MenuButtonTextColor,
//     MenuSelectFontSize,
//     // MenuButtonEditLink,
//     // MenuButtonImageUpload,
//     // MenuSelectFontSize,
// } from 'mui-tiptap';

// export default function RichTextComponent({ name, value, handleInputChange }) {
//     const editor = useEditor({
//         extensions: [
//             StarterKit,
//             Underline,
//             TextStyle,
//             Color,
//             Image,
//             FontSize,  // Add FontSize extension
//             Link.configure({
//                 openOnClick: false,
//                 autolink: false,
//                 linkOnPaste: false,
//             }),
//             TextAlign.configure({
//                 types: ['heading', 'paragraph'],
//             }),
//         ],
//         content: '<p style="font-size: 14px;">Custom editor content</p>',
//         editorProps: {
//             attributes: {
//                 style: 'font-size: 14px;',
//             },
//         },
//     });

//     return (
//         <RichTextEditorProvider editor={editor} onChange={() => handleInputChange(name, value)}>
//             <RichTextField
//                 controls={
//                     <MenuControlsContainer>
//                         <MenuSelectHeading />
//                         <MenuSelectFontSize />
//                         <MenuDivider />
//                         <MenuButtonBold />
//                         <MenuButtonItalic />
//                         <MenuButtonUnderline />
//                         <MenuDivider />
//                         <MenuButtonTextColor />
//                         <MenuDivider />
//                         <MenuButtonAlignLeft />
//                         <MenuButtonAlignCenter />
//                         <MenuButtonAlignRight />
//                         {/* <MenuDivider /> */}
//                         {/* <MenuButtonEditLink />
//                         <MenuButtonImageUpload /> */}
//                     </MenuControlsContainer>
//                 }
//                 placeholder="Start typing..."
//             />
//         </RichTextEditorProvider>
//     );
// }








import React, { useEffect } from 'react';
import { useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import Link from '@tiptap/extension-link';
import TextStyle from '@tiptap/extension-text-style';
import Color from '@tiptap/extension-color';
import Image from '@tiptap/extension-image';
// import FontSize from '@tiptap/extension-font-size';

import {
    RichTextEditorProvider,
    RichTextField,
    MenuControlsContainer,
    MenuSelectHeading,
    // MenuSelectFontSize,
    MenuButtonBold,
    MenuButtonItalic,
    MenuButtonUnderline,
    MenuDivider,
    MenuButtonAlignLeft,
    MenuButtonAlignCenter,
    MenuButtonAlignRight,
    MenuButtonTextColor,
} from 'mui-tiptap';

export default function RichTextComponent({ name, value, handleInputChange }) {
    // Initialize the editor
    const editor = useEditor({
        extensions: [
            StarterKit,
            Underline,
            TextStyle,
            Color,
            Image,
            // FontSize,  // Add FontSize extension
            Link.configure({
                openOnClick: false,
                autolink: false,
                linkOnPaste: false,
            }),
            TextAlign.configure({
                types: ['heading', 'paragraph'],
            }),
        ],
        content: value || '<p style="font-size: 14px;">Custom editor content</p>', // Ensure content is controlled
        editorProps: {
            attributes: {
                style: 'font-size: 14px;',
            },
        },
        onUpdate: ({ editor }) => {
            // Update the parent component when the content changes
            handleInputChange(name, editor.getHTML());
        },
    });

    // Effect to update editor content when value prop changes
    useEffect(() => {
        if (value !== editor?.getHTML()) {
            editor?.commands.setContent(value);
        }
    }, [value, editor]);

    return (
        <RichTextEditorProvider editor={editor}>
            <RichTextField
                controls={
                    <MenuControlsContainer>
                        <MenuSelectHeading />
                        {/* <MenuSelectFontSize /> */}
                        <MenuDivider />
                        <MenuButtonBold />
                        <MenuButtonItalic />
                        <MenuButtonUnderline />
                        <MenuDivider />
                        <MenuButtonTextColor />
                        <MenuDivider />
                        <MenuButtonAlignLeft />
                        <MenuButtonAlignCenter />
                        <MenuButtonAlignRight />
                    </MenuControlsContainer>
                }
                placeholder="Start typing..."
            />
        </RichTextEditorProvider>
    );
}
